import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #F1F1F1',
    borderRadius: '1rem',
    boxShadow: 'rgb(66 81 89 / 5%) 0px 4px 6px 0px',
    width: '100%',
    height: '100%'
  },

  tabs: {
    marginBottom: '1rem'
  },

  tab: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
